module.exports = __webpack_public_path__ + "img/ai-chat-inactive-icon.44c630a2.svg";